import React from "react";
import {useNavigate} from "react-router-dom";

const FavoriteMasterclasses = ({ masterClasses }) => {
    const navigate = useNavigate();

    const handleNavigate = (id) => {
        navigate("/master-classes/" + id);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            <div className="other-lessons p-3">
                <div className="mb-3">
                    <span className="fs-5 lh-base fw-bolder">
                        Favorites
                    </span>
                </div>

                <div className="favorites-list d-flex overflow-auto flex-nowrap gap-3 pb-2">
                    {masterClasses?.map((masterClass) => (
                        <div
                            key={masterClass.id}
                            className="favorite__masterclass card text-white cursor-pointer rounded-3 flex-shrink-0"
                            onClick={() => handleNavigate(masterClass.id)}
                        >
                            <img
                                src={masterClass?.cover_image}
                                className="card-img-top rounded-3"
                                alt={masterClass.name}
                            />
                            <div className="card-body p-2">
                                <span className="lh-base fw-bolder">
                                    {masterClass.name}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                <button className="btn btn-outline-primary-info mb-2" style={{width: "max-content"}}
                        onClick={() => navigate('/playlists/favorites')}>
                    Show more
                </button>
            </div>
        </>
    );
};

export default FavoriteMasterclasses;